export default __webpack_public_path__ + "images/referenzen/animationsfilm/edeka_joghurtdeckel_social_media_animation.mp4";